import { PageHeader, ProjectsTable, useAuth } from "@nexys/user-management-web";
import { Navigate, useNavigate } from "react-router-dom";

export const ProjectsPage = () => {
  const { hasUserRole } = useAuth();
  const navigate = useNavigate();
  if (!hasUserRole("superadmin")) return <Navigate to="/" replace />;

  return (
    <div className="grid gap-6">
      <PageHeader
        title="Products"
        description="Isolated user-management spaces, each with its own tenancy configuration. Click one to manage it."
      />
      <ProjectsTable onSelect={(id) => navigate(`/products/${id}`)} />
    </div>
  );
};
